import http from '@/requests/http'

class Template {
  static all (params) {
    return http.post('messages/template/index', params)
  }
  static view (params) {
    return http.post('messages/template/view', params)
  }
  static async update (data) {
    return http.post('messages/template/update', data)
  }
  static async save (data) {
    return http.post('messages/template/store', data)
  }
  static async export () {
    return http.post('messages/template/export')
  }
  static async delete (id) {
    return http.post(`messages/template/delete/${id}`)
  }
}

export default Template
